/* =============================================================================
   VIEWS / ADMIN / SETTINGS-COMPLIANCE — Compliance-Sub-Tab (TSE / DSGVO / GoBD)
   =============================================================================
   S79 REF-6: aus settings.js extrahiert (Subsection-Renderer des „Compliance"-
   Sub-Tabs):
     - renderComplianceTseSubsection()    TSE/KassenSichV (Skeletons aus settings-compliance-tse.js)
     - renderComplianceDsgvoSubsection()  DSGVO (Wrapper um renderGdprSection aus settings-gdpr.js)
     - renderComplianceGobdSubsection()   GoBD-Verfahrensdoku-Hinweis (statisch)

   Der dünne Dispatcher `renderComplianceSection()` + die Sub-Sub-Tab-Bar bleiben
   im Haupt-`settings.js` (Cross-Cutting, Anti-Circular). Die async TSE-Daten
   (refreshTseSettings/refreshTseOrphanCard/_wireTseOrphanSubscription) bleiben
   ebenfalls dort — sie werden im renderSettings-Lifecycle getriggert.
============================================================================ */

import {
  tseSettingsSkeleton,
  tseOrphanSkeleton
} from './settings-compliance-tse.js';
import { renderGdprSection } from './settings-gdpr.js';

export function renderComplianceTseSubsection() {
  // S82-5: Die TSE-Orphan-Reconciliation ist eine Owner-Aktion — die RPC
  // `tse_pending_list_orphans` ist owner/admin-gated. Im Read-Only-Manager-
  // Blick lassen wir die Orphan-Karte weg (sonst „konnte nicht laden"-Fehler);
  // der TSE-STATUS (get_tse_config, für alle aktiven User lesbar) bleibt sichtbar.
  const auth = (typeof window !== 'undefined' && window.App && window.App.auth) || null;
  const readOnly = !!(auth && typeof auth.isSettingsSubTabReadOnly === 'function'
                    && auth.isSettingsSubTabReadOnly('compliance'));
  return `
    <div class="card" id="tse-settings-card">
      ${tseSettingsSkeleton()}
    </div>
    ${readOnly ? '' : `
    <div class="card" id="tse-orphan-card" style="margin-top: 20px;">
      ${tseOrphanSkeleton()}
    </div>`}
  `;
}

export function renderComplianceDsgvoSubsection() {
  return `${renderSecurityAutoLogoutCard()}${renderGdprSection()}`;
}

/** S140 — Auto-Logout-Card: globaler MainUser-Idle-Timeout (Sicherheits-Kontext).
 *  Reines client-Config-Feld (geht über updateSettingClampedInt → updateSetting,
 *  kein server-hochgezähltes Feld → unkritisch ggü. Full-PUT-Clobber). Clamp
 *  15–720, Default 180 (kein echtes „Aus" für den MainUser). */
export function renderSecurityAutoLogoutCard() {
  const state = (typeof window !== 'undefined' && window.App && window.App.storage
                 && window.App.storage._getInternalState()) || { settings: {} };
  const raw = state.settings && state.settings.mainUserIdleTimeoutMinutes;
  const val = Number.isFinite(parseInt(raw, 10)) ? parseInt(raw, 10) : 180;
  return `
    <div class="card">
      <h2>🔒 Auto-Logout bei Inaktivität</h2>
      <p class="hint" style="margin:.2rem 0 1rem;">
        Der angemeldete Hauptnutzer (Konto-Login) wird nach dieser Zeit ohne
        Aktivität automatisch abgemeldet — zusätzlich zur geräte-spezifischen
        Operator-Sperre. Schützt offen gelassene Geräte. Wert gilt global,
        15–720 Minuten (kein vollständiges Deaktivieren).
      </p>
      <div class="field" style="max-width:320px;">
        <label style="font-size:.85rem;">Auto-Logout nach Inaktivität (Minuten)</label>
        <input type="number" min="15" max="720" step="15" value="${val}"
               oninput="updateSettingClampedInt('mainUserIdleTimeoutMinutes', this.value, 15, 720, 180)">
      </div>
    </div>
  `;
}

export function renderComplianceGobdSubsection() {
  return `
    <div class="card">
      <h2>📋 GoBD-Verfahrensdokumentation</h2>
      <p class="hint">
        Die Verfahrensdokumentation gemäß GoBD beschreibt das Kassen- und
        Bestellsystem für Betriebsprüfungen. Sie liegt im Repository unter
        <code>docs/gobd-verfahrensdokumentation.md</code> und wird bei jeder
        Schema-Änderung nachgepflegt.
      </p>
      <p class="hint" style="margin-top: 12px;">
        <strong>Aufbewahrungsfristen (§147 AO):</strong> 10 Jahre für alle
        steuerrelevanten Belege (Bons, Z-Bons, TSE-Logs, DSFinV-K-Exporte).
        Die DB-Migration enthält keine automatische Löschung — manuelle
        Archivierung beim Steuerberater wird empfohlen.
      </p>
    </div>
  `;
}
